import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-card-coupons .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const cardCount = parseInt(slider?.dataset?.cardCount ?? 4);
		const mobileSlidesPerView = 1;
		let tabletSlidesPerView = 2;
		let desktopSmallSlidesPerView = 3;
		let desktopSlidesPerView = 4;

		if (cardCount <= 2) {
			return;
		}

		if (cardCount === 3) {
			desktopSlidesPerView = 3;
		}

		const block = slider.closest('.block-card-coupons');

		if (
			block.classList.contains(
				'block-card-coupons--inside-content-side-image'
			)
		) {
			desktopSlidesPerView = 1;
			desktopSmallSlidesPerView = 1;
			tabletSlidesPerView = 1;
		}

		const paginationElement =
			slider.parentElement.querySelector('.swiper-pagination');

		const settings = {
			loop: false,
			grabCursor: true,
			slidesPerView: mobileSlidesPerView,
			centeredSlides: false,
			spaceBetween: 8,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			pagination: {
				el: paginationElement,
				clickable: false,
				dynamicBullets: false,
			},
			breakpoints: {
				768: {
					slidesPerView: tabletSlidesPerView,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: desktopSmallSlidesPerView,
					spaceBetween: 32,
				},
				1440: {
					slidesPerView: desktopSlidesPerView,
					spaceBetween: 32,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
